// src/specialWords.js
// Add your special words here as key-value pairs
// Example: 'kandhamal': 'କନ୍ଧମାଳ',

const specialWords = {
  // Add up to 2000 or more entries here

  
 
};
export default specialWords;
